import React, { FC } from 'react';
import './NewLayout.css';
import { Widget } from '@/Shared/UI/Components';
import { useAppNavigation } from '@/Shared/Logic';
import { ActionResponse } from '@/Shared/Types';

interface NewLayoutProps { }

const NewLayout: FC<NewLayoutProps> = () => {

	const { goToForm } = useAppNavigation();

	const actionButtons = [
		{
			label: "mandat",
			class: "green-button",
			onclick: () => goToForm("Mandate")
		},
		{
			label: "bien",
			class: "green-button",
			onclick: () => goToForm("Property")
		},
		{
			label: "contact",
			class: "blue-button",
			onclick: () => goToForm("Contact")
		},
		{
			label: "transaction",
			class: "blue-button",
			onclick: () => goToForm("Transaction")
		},

	]

	return (

		<Widget
		    domainLabel='Nouveau'
			response={{} as ActionResponse}
			title='Nouveau'
			content={
				<div className="NewLayout flex-col" data-testid="NewLayout">
					<div className='NewLayout__action-list flex-row'>
						{
							actionButtons.map((action, index) =>
								<button
									key={index}
									className={`action-button ${action.class}`}
									onClick={() => action.onclick()
									}>
									{action.label}
								</button>
							)
						}
					</div>
				</div>
			}
		/>


	);
}

export default NewLayout;
